import React from "react"

import "./filter-multi-check.scss"

const FilterMultiCheck = props => {
  const {
    currentSubcategory,
    title,
    options,
    handleChangeFilter,
    numfilter,
    activeFilters,
    titleProduct
  } = props
  const [curtain, setCurtain] = React.useState(false)
  const changeTtleByCountry = title => {
    if (process.env.LOCALE === "es-CL") {
      switch (title) {
        case "Tipo de piel":
          return "Tipo de cubierta"
        case "Tipo de actividad":
          return "Tipo de uso"

        default:
          return title
      }
    } else {
      return title
    }
  }

  const changeLabelByCountry = (label, title) => {
  if (process.env.LOCALE === "es-AR" || process.env.LOCALE === "es-UY") {
      switch (label) {
        case "Panty":
          return "Vedetina"
        case "Cachetero":
          return "Culotte"
        default:
          return label
      }
    } else if(process.env.LOCALE === "es-CO"){
        if(title === "Tipo de toalla" || title === "Tipo de protectores"){ 
          if(titleProduct === "Toallas Higiénicas"){
            switch (label) {
              case "Extra Larga":
                return "Extra Larga (32 Cm)"
              case "Normal":
                return "Normal (24 Cm)"
              case "Larga":
                return "Larga (28 Cm)"  
              default:
                return label
            }
          }else if (props.titleProduct === "Protectores Diarios"){
            switch (label) {
              case "Larga":
                return "Largo"
              default:
                return label
            }
          }
        }
        switch (label) {
          case "Panty":
            if (title === "Ropa interior") {
              return "Normal"
            }
          case "Activa":
            return "Día"
          case "Dormir":
            return "Noche"
          case "Digital":
            return "Sin aplicador"  
          default:
            return label
        }
 
    } else if (process.env.LOCALE === "es-CL") {
      switch (label) {
        case "Panty":
          return "Bikini"
        case "Cachetero":
          return "Pantaletas"
        case "Tanga":
          return "Colaless"
        case "Sensible":
          return "Suave"
        case "Activa":
          return "Día"
        case "Dormir":
          return "Noche"
        case "Normal":
          if (title == "Tipo de piel") {
            return "Malla"
          } else {
            return label
          }
        default:
          return label
      }
    } else if (process.env.LOCALE === "es-PY") {
      switch (label) {
        case "Panty":
          return "Bikini"
        case "Cachetero":
          return "Culotte"
        default:
          return label
      }
    } else {
      return label
    }
  }

  return (
    <>
      {process.env.LOCALE === "es-DO" &&
      currentSubcategory === "protectores-diarios" &&
      title === "Tipo de actividad" ? null : (
        <div className="f-filterMultiCheck">
          <span className="f-Filter-title">{changeTtleByCountry(title)}</span>
          <div className="f-filterMultiCheck-options">
            {options.map((label, index) => {
              return (
                <label key={index} className="container">
                  {changeLabelByCountry(label, title)}
                  <input
                    type="checkbox"
                    checked={
                      activeFilters.find(x => x.id === numfilter + index)
                        ? activeFilters.find(x => x.id === numfilter + index)
                            .value
                        : false
                    }
                    onChange={() => {
                      if (curtain) {
                        setCurtain(false)
                      } else {
                        setCurtain(true)
                      }
                      handleChangeFilter(label, label, numfilter + index, title)
                    }}
                  />
                  <span className="checkmark"></span>
                </label>
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}

export default FilterMultiCheck
